// import "../assets/css/style.css";

const serviceCards = [
  {
    id: 1,
    title: "Beginner-Focused Learning",
    description: "Easy resources that simplify trading concepts.",
  },
  {
    id: 2,
    title: "Guided by experts",
    description: "Learn and grow with experienced trader support.",
  },
  {
    id: 3,
    title: "Secure and transparent",
    description: "Trade safely with strong security and clear pricing.",
  },
  {
    id: 4,
    title: "Real-time insights",
    description: "Get live data and updates to make smarter decisions.",
  },
  {
    id: 5,
    title: "All-in-one platform",
    description: "Trade Forex, Crypto, and Stocks in one place.",
  },
  {
    id: 6,
    title: "Seamless Experience",
    description:
      "Enjoy fast execution, smooth navigation, and 24/7 support.",
  },
];

const QualityProcessSection = () => {
  return (
    <section className="quality-section">
      <div className="quality-header">
        <h1>Trade with Confidence</h1>
        <p>
          Take control with simple tools, transparent pricing, and reliable
          support from The Pips.
        </p>
      </div>

      <div className="quality-grid">
        <div className="quality-column left">
          {serviceCards.slice(0, 3).map((card) => (
            <div key={card.id} className="quality-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>

        <div className="quality-center">
          {/* Added 'floating-image' class */}
          <img
            src="/images/home/home3.png"
            alt="Trading Platform Preview"
            className="floating-image"
          />
        </div>

        <div className="quality-column right">
          {serviceCards.slice(3, 6).map((card) => (
            <div key={card.id} className="quality-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QualityProcessSection;
